import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';

const MinimizedBar = ({ title = 'Minimized', onRestore, onClose, minWidth = 200 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ml: 1,
        px: 1.5,
        height: 36,
        minWidth,
        background: '#f5f5f5',
        borderRadius: '6px',
        border: '1px solid #ddd'
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }} >
        {title}
      </Typography>

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <IconButton size="small" onClick={onRestore} sx={{ color: 'text.primary' }}>
          <OpenInFullIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default MinimizedBar;